import { CircleCheckFilled } from 'baseui/icon'
import useFidelityMaximizerSidebar from './useFidelityMaximizerSidebar'
import { MailIcon, ChartIcon, PersonIcon, PhoneIcon } from './icons'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconCarbonBadge from '@/shared/icons/IconCarbonBadge'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import {
  HeaderActions,
  ModuleContent,
  ModuleIndicator,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import {
  StyledContainer,
  StyledTopContainer,
  StyledCurrentValue,
  StyledSubtitle,
  StyledProgressBarContainer,
  StyledProgressTrack,
  StyledProgressMask,
  StyledItemsContainer,
  StyledItemRow,
  StyledItemLeft,
  StyledItemLabel,
  StyledDoneIcon,
  StyledPendingIcon,
} from './styled-components'

const ITEM_ICONS = {
  nlbp_classic: MailIcon,
  nlbp_personalized: ChartIcon,
  myselectra: PersonIcon,
  app_downloaded: PhoneIcon,
}

const FidelityMaximizerSidebar = () => {
  const { hidden, title, subtitle, items, currentValue, maxValue, isMastered, percentDone } =
    useFidelityMaximizerSidebar()
  const { expanded, toggle, panelExpanded } = useModuleCollapse('fidelity-maximizer')

  if (hidden) {
    return null
  }

  return (
    <StyledContainer $mastered={isMastered}>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonBadge} moduleKey='fidelity-maximizer'>
          {title}
        </ModuleHeading>
        <HeaderActions>
          <ModuleIndicator>
            <StyledCurrentValue $reachedMax={isMastered}>{currentValue}</StyledCurrentValue>/{maxValue}
          </ModuleIndicator>
          <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='fidelity-maximizer' />
        </HeaderActions>
      </ModuleHeader>
      <StyledTopContainer hidden={!panelExpanded}>
        <StyledSubtitle hidden={!subtitle}>{subtitle}</StyledSubtitle>
        <StyledProgressBarContainer>
          <StyledProgressTrack $mastered={isMastered}>
            <StyledProgressMask $percentDone={percentDone} />
          </StyledProgressTrack>
        </StyledProgressBarContainer>
      </StyledTopContainer>
      <ModuleContent hidden={!expanded}>
        <StyledItemsContainer>
          {items.map(item => {
            const PendingIcon = ITEM_ICONS[item.key]
            return (
              <StyledItemRow key={item.key} $done={item.done}>
                <StyledItemLeft>
                  {item.done ? (
                    <StyledDoneIcon>
                      <CircleCheckFilled size={20} />
                    </StyledDoneIcon>
                  ) : (
                    <StyledPendingIcon>
                      <PendingIcon size={20} />
                    </StyledPendingIcon>
                  )}
                  <StyledItemLabel $done={item.done}>{item.label}</StyledItemLabel>
                </StyledItemLeft>
              </StyledItemRow>
            )
          })}
        </StyledItemsContainer>
      </ModuleContent>
    </StyledContainer>
  )
}

export default FidelityMaximizerSidebar
